<template>
	<el-tooltip
		:disabled="curRow == content && !isShowTooltip"
		:placement="placement"
		:effect="effect"
	>
		<template #content>
			<div :class="['tooltip-div', { active: isActive }]">{{ content }}</div>
		</template>
		<div class="list textOverflow" ref="textRef" @mouseenter="mouseenterChange($event, content)">
			{{ content === '' ? '-' : content }}
		</div>
	</el-tooltip>
</template>

<script setup>
import { ref, onMounted, onUnmounted, toRefs } from 'vue'
import { useBaseMixins } from '@/views/base_mixins.js'
const { isShowTooltip, curRow, mouseenterChange } = useBaseMixins()
const props = defineProps({
	placement: {
		type: String,
		default: ''
	},
	content: {
		type: [String, Number, Array],
		default: ''
	},
	effect: {
		type: String,
		default: ''
	},
	isActive: {
		type: Boolean,
		default: false
	}
})
let { placement, content, effect } = toRefs(props)
onMounted(() => {})

onUnmounted(() => {})
</script>

<style lang="scss" scoped>
.list {
	cursor: pointer;
	text-overflow: ellipsis;
	overflow: hidden;
	word-break: break-all;
	white-space: nowrap;
}
.tooltip-div {
	max-width: 300px;
}

.active {
	max-width: 1200px;
}
</style>
